// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import DisplayEntityInfo, { EntityInfoType } from '@Organisms/DisplayEntityInfo/DisplayEntityInfo';
import React, { ReactElement } from 'react';

import './MultipleDisplayEntityInfo.scss';

interface MultiFieldEntityInfoType extends EntityInfoType {
    hide?: boolean;
}
interface MultipleDisplayEntityInfoProps {
    data: MultiFieldEntityInfoType[];
    className?: string;
}

export const MultipleDisplayEntityInfo = ({ data = [], className }: MultipleDisplayEntityInfoProps): ReactElement => {
    return (
        <div className={classList('multiple-display-entity-info', className)}>
            {data.reduce((acc, { hide = false, ...info }, index): ReactElement[] => {
                return !hide ? [...acc, <DisplayEntityInfo {...info} key={`display-${index}`} />] : acc;
            }, [] as ReactElement[])}
        </div>
    );
};
